export const getFileNameWithoutExtension = (name: string): string => {
    const nameArray = name.split('.');
    nameArray.pop();
    return nameArray.join();
};
